/* Jackery-style wattage/runtime calculator. Uses the section's
   data-jp-capacity (Wh) and an 85% usable-capacity assumption. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.jackery-calc').forEach(function (root) {
    var capacityWh = parseFloat(root.dataset.jpCapacity || '1000');
    var EFFICIENCY = 0.85;
    var rowsWrap = root.querySelector('[data-jp-calc-rows]');
    var addRowBtn = root.querySelector('[data-jp-calc-add-row]');
    var calcBtn = root.querySelector('[data-jp-calc-run]');
    var resultEl = root.querySelector('[data-jp-calc-result]');
    var presetBtns = root.querySelectorAll('[data-jp-preset-watt]');

    function addRow(nameVal, wattVal) {
      var row = document.createElement('div');
      row.className = 'jackery-calc__row';
      row.innerHTML =
        '<label>Device: <input type="text" class="jackery-calc__device-name" placeholder="e.g. Mini fridge" value="' + (nameVal || '') + '"></label>' +
        '<label>Watts:' +
          '<span class="jackery-calc__watts-wrap">' +
            '<input type="number" class="jackery-calc__device-watts" min="0" value="' + (wattVal || 0) + '"> W' +
          '</span>' +
        '</label>' +
        '<button type="button" class="jackery-calc__remove-row" data-jp-calc-remove-row aria-label="Remove device">&times;</button>';
      rowsWrap.appendChild(row);
      updateRemoveButtons();
    }

    function updateRemoveButtons() {
      var rows = rowsWrap.querySelectorAll('.jackery-calc__row');
      var removeBtns = rowsWrap.querySelectorAll('[data-jp-calc-remove-row]');
      // Keep at least one row on the page — hide remove buttons when only one is left.
      removeBtns.forEach(function (btn) {
        btn.hidden = rows.length <= 1;
      });
    }

    rowsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-jp-calc-remove-row]');
      if (!btn) return;
      var row = btn.closest('.jackery-calc__row');
      var rows = rowsWrap.querySelectorAll('.jackery-calc__row');
      if (row && rows.length > 1) {
        row.remove();
        updateRemoveButtons();
      }
    });

    updateRemoveButtons();

    if (addRowBtn) {
      addRowBtn.addEventListener('click', function () { addRow('', 0); });
    }

    function findEmptyRow() {
      var rows = rowsWrap.querySelectorAll('.jackery-calc__row');
      for (var i = 0; i < rows.length; i++) {
        var nameInput = rows[i].querySelector('.jackery-calc__device-name');
        var wattsInput = rows[i].querySelector('.jackery-calc__device-watts');
        var nameEmpty = !nameInput || !nameInput.value.trim();
        var wattsEmpty = !wattsInput || !parseFloat(wattsInput.value);
        if (nameEmpty && wattsEmpty) return rows[i];
      }
      return null;
    }

    presetBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var name = btn.dataset.jpPresetName || btn.textContent.trim();
        var watts = btn.dataset.jpPresetWatt;
        var emptyRow = findEmptyRow();
        if (emptyRow) {
          emptyRow.querySelector('.jackery-calc__device-name').value = name;
          emptyRow.querySelector('.jackery-calc__device-watts').value = watts;
        } else {
          addRow(name, watts);
        }
      });
    });

    if (calcBtn) {
      calcBtn.addEventListener('click', function () {
        var wattInputs = rowsWrap.querySelectorAll('.jackery-calc__device-watts');
        var totalWatts = 0;
        wattInputs.forEach(function (input) {
          totalWatts += parseFloat(input.value) || 0;
        });
        if (totalWatts <= 0) {
          resultEl.textContent = '00';
          return;
        }
        var hours = (capacityWh * EFFICIENCY) / totalWatts;
        resultEl.textContent = hours.toFixed(1);
      });
    }
  });
});
